<template>
  <div v-if="!$auth.loading" id="app">
    <div v-if="$route.meta.public">
      <router-view />
    </div>
    <div v-else :key="activeCustomer ? activeCustomer._id : null">
      <FullLoader v-if="!initialized" />
      <router-view v-if="initialized" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import FullLoader from '@/components/MainContent/FullLoader.vue'
import Ably from '@/plugins/ably'
import LaunchDarkly from '@/plugins/launch-darkly'
import { getInstance } from '@/plugins/auth'
import { mapActions, mapState, mapGetters } from 'vuex'
import { ENVIRONMENTS } from '@/utils/constants'

const App = Vue.extend({
  name: 'App',
  components: {
    FullLoader,
  },
  computed: {
    ...mapState('customer', ['activeCustomer', 'customer']),
    ...mapGetters('environment', ['accessNotEnabled']),
  },
  data: () => ({
    initialized: false,
  }),
  methods: {
    ...mapActions('environment', ['updateActiveEnvironment']),
  },
  async mounted() {
    const authService = getInstance()

    authService.$watch('loading', async (loading: boolean) => {
      if (loading === false && authService.isAuthenticated) {
        Vue.use(Ably)

        Vue.use(LaunchDarkly, {
          kind: 'user',
          key: authService.user.sub,
          customer: this.customer.name,
        })
        try {
          await this.$launchDarkly.waitForInitialization()
        } catch (e) {
          Sentry.captureException(e)
        }

        if (this.accessNotEnabled) {
          await this.updateActiveEnvironment(ENVIRONMENTS.SANDBOX)
        }

        this.initialized = true
      }
    })
  },
})

export default App
</script>

<style lang="scss">
@import './styles/App.scss';
</style>
